const initialState = null; // Initial state

const Ibleaddetailsreducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_IBLEADDETAIL':
        console.log("ibleaddetail",action);
      return action.payload; // Set the session value
    
    default:
      return state;
  }
};

export default Ibleaddetailsreducer;